<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Kode Affiliate</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved: 60px"
            >
                <div class="wallet-card">
                    <div class="balance mb-0 element-copy">
                        <router-link
                            :to="{ name: 'referral.index' }"
                            class="col-6 text-left"
                        >
                            <span class="title">Kode Affiliate</span>
                            <div
                                class="total truncate-text"
                                style="font-size: 15px"
                            >
                                <span class="this-copy">{{
                                    customer.affiliate_id
                                }}</span>
                            </div>
                        </router-link>
                        <div class="col-6 text-right">
                            <button
                                class="btn btn-warning btn-sm text-nowrap mr-1 pt-2 pb-2"
                                @click="copy"
                            >
                                <ion-icon
                                    name="copy-outline"
                                    class="mr-0"
                                ></ion-icon>
                            </button>
                            <button
                                class="btn btn-primary btn-sm text-nowrap pt-2 pb-2"
                                @click="actionSheet('show')"
                            >
                                <ion-icon
                                    name="create-outline"
                                    class="mr-0"
                                ></ion-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" style="margin-top: 40px">
                <div class="detail-card text-center">
                    <h3 for="">QR Kode Affiliate</h3>
                    <qr-code
                        :link="
                            url_landingpage +
                            '?affiliate_code=' +
                            customer.affiliate_id
                        "
                        :size="200"
                    />
                    <h4>Bagikan Kode Affiliate</h4>

                    <a
                        :href="
                            'https://api.whatsapp.com/send?text=💡 Mau Punya Penghasilan Tambahan?%0AGabung jadi Mitra ' +
                            VUE_ENV.VUE_APP_NAME +
                            '!%0A%0ABuka peluang usaha baru dengan modal HP aja. Daftar pakai kode Affiliate *' +
                            customer.affiliate_id +
                            '* dan dapatkan kejutan menarik!%0A%0A📲 Yuk, gabung sekarang: ' +
                            url_landingpage +
                            '?affiliate_code=' +
                            customer.affiliate_id
                        "
                        target="_blank"
                        class="btn btn-icon btn-outline-success mr-1"
                        ><ion-icon name="logo-whatsapp"></ion-icon
                    ></a>
                    <a
                        :href="
                            'https://www.facebook.com/sharer/sharer.php?u=' +
                            url_landingpage +
                            '?affiliate_code=' +
                            customer.affiliate_id
                        "
                        target="_blank"
                        class="btn btn-icon btn-outline-primary mr-1"
                        ><ion-icon name="logo-facebook"></ion-icon
                    ></a>
                    <a
                        href="https://www.instagram.com/"
                        target="_blank"
                        class="btn btn-icon btn-outline-danger mr-1"
                        ><ion-icon name="logo-instagram"></ion-icon
                    ></a>
                    <a
                        href="https://www.tiktok.com/"
                        target="_blank"
                        class="btn btn-icon btn-outline-secondary"
                        ><ion-icon name="logo-tiktok"></ion-icon
                    ></a>
                </div>
            </div>
            <div class="section inset mt-2 mb-2">
                <div class="accordion" id="faq">
                    <div class="item" v-for="(item, index) in faq" :key="index">
                        <div class="accordion-header">
                            <button
                                class="btn collapsed text-left"
                                type="button"
                                data-toggle="collapse"
                                :data-target="'#faq_' + item.posisi"
                            >
                                <b>{{ item.question }}</b>
                            </button>
                        </div>
                        <div
                            :id="'faq_' + item.posisi"
                            class="accordion-body collapse"
                            data-parent="#faq"
                        >
                            <div class="accordion-content">
                                {{ item.answer }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <action-sheet
            ref="edit_kode_referral"
            :title="'Ubah Kode Affiliate'"
            :inset="true"
        >
            <div class="form-group boxed">
                <label class="label">Atur Kode Affiliate</label>
                <input
                    type="text"
                    class="form-control form-control-sm text-uppercase"
                    v-model="affiliate_id"
                    oninput="this.value = this.value.replace(/[^a-z0-9]/gi, '')"
                />
                <small><i>Min. 3 digit dan Maks. 15 digit</i></small>
            </div>
            <div class="form-group mt-2">
                <h5>Syarat & Ketentuan</h5>
                <div style="font-size: 13px; line-height: 18px">
                    <ol>
                        <li>Akun sudah terverifikasi</li>
                        <li>
                            Kode Affiliate lama Kamu (<b>DF{{ customer.id }}</b
                            >) dan (<b>QF{{ customer.id }}</b
                            >) masih dapat digunakan
                        </li>
                        <li>
                            Kode Affiliate tidak boleh mengandung SARA dan
                            Pornografi
                        </li>
                        <li>
                            Merubah Kode Affiliate akan menggantikan Kode
                            Affiliate sebelumnya
                        </li>
                        <li>Tentukan Kode Affiliate dengan bijak</li>
                    </ol>
                </div>
            </div>
            <div class="form-group basic">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-secondary btn-block"
                            @click="actionSheet('hide')"
                        >
                            Batal
                        </button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary btn-block'"
                            @click.native="updateKodeReferral()"
                            >Simpan</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import $axios from './../../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        data() {
            return {
                affiliate_id: '',
                url_landingpage: 'https://landing.kaezen.id',
                loadingApp: true,
                loadingButton: false,
                komisi: 0,
                messageShare:
                    '💡 Mau punya penghasilan tambahan? Gabung jadi Mitra ' +
                    this.VUE_ENV.VUE_APP_NAME +
                    '!',
                faq: [
                    {
                        posisi: 1,
                        question: 'Apa itu Kode Affliate',
                        answer:
                            'Kode Affiliate adalah sebuah kode unik pengguna ' +
                            this.VUE_ENV.VUE_APP_NAME +
                            ' yang bisa dibagikan ke kerabat, teman atau keluarga untuk ikut bergabung menggunakan ' +
                            this.VUE_ENV.VUE_APP_NAME +
                            '.',
                    },
                    {
                        posisi: 2,
                        question: 'Cara kerja kode Affiliate?',
                        answer: 'Dengan membagikan atau salin kode affiliate, kamu bisa membagikan kode affiliatemu ke orang lain melalui media sosial seperti whatsapp, facebook, instagram, dll. Lalu orang lain yang kamu ajak akan di arahkan untuk melakukan pendaftaran dan download aplikasi melalui link yang telah disediakan.',
                    },
                    {
                        posisi: 3,
                        question: 'Apakah Kode Affiliate bisa diubah?',
                        answer: 'Ya, Kode Affiliate dapat kamu ubah sesuai keinginan, kode affiliate terdiri dari 5-15 digit huruf atau angka.',
                    },
                    {
                        posisi: 4,
                        question: 'Berapa penghasilan yang saya dapatkan?',
                        answer: 'Kamu akan mendapatkan penghasilan dalam bentuk komisi dari setiap transaksi downline kamu sebesar Rp 25/transaksi. Kamu juga berkesempatan mendapatkan bonus komisi dengan menjadi agen affiliate plus dan mengikuti program-program agen affiliate plus yang tersedia.',
                    },
                    {
                        posisi: 5,
                        question:
                            'Kapan saya bisa mendapatkan penghasildan dari affiliate?',
                        answer: 'Kamu akan mendapatkan penghasilan dari affiliate setiap kali downline melakukan transaksi. Semakin sering downline bertransaksi semakin besar penghasilan yang kamu dapatkan.',
                    },
                ],
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            copy: function (e) {
                this.$store.commit('SET_TOAST', {
                    show: false,
                });
                let text = window
                    .$(e.target)
                    .parents('.element-copy')
                    .find('.this-copy')[0].innerText;

                let element = document.createElement('textarea');
                document.body.appendChild(element);
                element.value = text;
                element.select();
                document.execCommand('copy');
                document.body.removeChild(element);
                this.$store.commit('SET_TOAST', {
                    show: true,
                    message: 'Berhasil disalin',
                    tipe: 'default',
                    icon: 'success',
                    position: 'center',
                });
            },
            actionSheet(value) {
                if (value == 'show') {
                    if (
                        this.customer.account_verified_data.status == 'APPROVED'
                    ) {
                        let element = this.$refs.edit_kode_referral.$el;
                        window.$(element).modal(value);
                    } else {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message:
                                'Fitur ini hanya bisa digunakan oleh mitra yang telah melakukan verifikasi data diri.',
                            tipe: 'default',
                            icon: 'warning',
                        });
                    }
                } else {
                    let element = this.$refs.edit_kode_referral.$el;
                    window.$(element).modal(value);
                    this.affiliate_id = '';
                }
            },
            updateKodeReferral() {
                this.loadingButton = true;
                $axios
                    .post('/referral/update-kode-referral', {
                        affiliate_id: this.affiliate_id,
                    })
                    .then(() => {
                        this.getCustomer();
                        this.loadingButton = false;
                        this.actionSheet('hide');
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: 'Berhasil',
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.actionSheet('hide');
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.loadingButton = false;
                    });
            },
        },
        mounted() {
            this.getSetting()
                .then(() => {
                    if (this.customer.role == 'Member') {
                        this.komisi =
                            this.setting.komisi_transaction_referral_basic;
                    } else if (this.customer.role == 'Premium') {
                        this.komisi =
                            this.setting.komisi_transaction_referral_premium;
                    } else if (this.customer.role == 'Bisnis') {
                        this.komisi =
                            this.setting.komisi_transaction_referral_premium;
                    } else if (this.customer.role == 'H2H') {
                        this.komisi = 0;
                    } else if (this.customer.role == 'MD') {
                        this.komisi = 100;
                    }
                    this.loadingApp = false;
                })
                .catch(() => {
                    this.loadingApp = false;
                });
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
